import { SOCIAL_MEDIA_TYPE_ENUM } from 'types/global';

const { FACEBOOK, LINKEDIN, PINTEREST, TUMBLR, TWITTER } = SOCIAL_MEDIA_TYPE_ENUM;

export default function shareImageOnSocialMedia({
  smType,
  openInNewTab,
  imageViewPageUrl,
}: {
  smType: any;
  imageViewPageUrl: string;
  openInNewTab?: boolean;
}) {
  const windowParams = 'toolbar=0,status=0,width=626,height=436';
  const url = encodeURIComponent(imageViewPageUrl);
  const socialLinks = {
    [FACEBOOK]: `https://www.facebook.com/sharer.php?u=${url}`,
    [PINTEREST]: `https://www.pinterest.com/pin/create/button/?url=${url}`,
    [TWITTER]: `https://twitter.com/intent/tweet?url=${url}`,
    [LINKEDIN]: `https://www.linkedin.com/shareArticle?url=${url}`,
    [TUMBLR]: `https://www.tumblr.com/widgets/share/tool?posttype=link&url=${url}`,
  };

  window.open(socialLinks[smType], `share${smType}`, openInNewTab ? undefined : windowParams);
}
